export default {
  seeCollection: 'Ver todas',
  subtopicsPlaceholder: 'Elige hasta 3 temáticas y sub-temáticas'
}

export const en = {
  seeCollection: 'See all',
  subtopicsPlaceholder: 'Choose up to 3 topics and sub-topics'
}

export const ca = {
  seeCollection: 'Veure totes',
  subtopicsPlaceholder: 'Tria fins a 3 temàtiques i sub - temàtiques'
}
